<template>
	<div>
		<template v-if="isMultiblock == 'true'">
			<div class="content" :class="{'container-lg': isMultiblock == 'false'}">
				<div class="row">
					<div class="col-12">
						<h2 v-if="textData.config.title">{{ textData.config.title }}</h2>
						<span class="text" v-html="textData.config.text"></span>
					</div>
				</div>
			</div>
		</template>
		<template v-else>
			<section :id="['container-' + index + '-' + textData.type]" :class="['container-' + textData.type]">
				<div class="content" :class="{'container-lg': isMultiblock == 'false'}">
					<div class="row">
						<div class="col-12">
							<h2 v-if="textData.config.title">{{ textData.config.title }}</h2>
							<span class="text" v-html="textData.config.text"></span>
						</div>
					</div>
				</div>
			</section>
			<hr class="horizontal-line">
		</template>
	</div>
</template>

<script>
export default {
	props: {
    textData: {
      type: Object
    },
		index: {
			type: Number
		},
		isMultiblock: {
			type: String
		}
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/design-turin/textComponent.scss";
</style>